import { LineLayers } from '../layers/LineLayers';
import { MarkerLayers } from '../layers/MarkerLayers';
import { TextLayers } from '../layers/TextLayers';

export class Layers {
    static bikeCheckpoints = () => {
        const id = 'bike-checkpoints';
        const circleRadius = 11;
        const backgroundColor = '#db001b';
        const textSize = 14;
        const textColor = '#ffffff';

        return TextLayers.circleWithText(
            id,
            circleRadius,
            backgroundColor,
            textSize,
            textColor
        );
    };

    static bikeCourse = () => {
        const id = 'bike-course';
        const lineColor = '#db001b';
        const lineWidth = 4;
        const shadowColor = '#f7f7f7';
        const shadowWidth = 7;

        return LineLayers.lineWithShadow(
            id,
            lineColor,
            lineWidth,
            shadowColor,
            shadowWidth
        );
    };

    static runningCheckpoints = () => {
        const id = 'running-checkpoints';
        const circleRadius = 11;
        const backgroundColor = '#93117e';
        const textSize = 14;
        const textColor = '#ffffff';

        return TextLayers.circleWithText(
            id,
            circleRadius,
            backgroundColor,
            textSize,
            textColor
        );
    };

    static runningCourse = () => {
        const id = 'running-course';
        const lineColor = '#93117e';
        const lineWidth = 4;
        const shadowColor = '#f7f7f7';
        const shadowWidth = 7;

        return LineLayers.lineWithShadow(
            id,
            lineColor,
            lineWidth,
            shadowColor,
            shadowWidth
        );
    };

    static swimmingCourse = () => {
        const id = 'swimming-course';
        const lineColor = '#1971a3';
        const lineWidth = 4;
        const shadowColor = '#f7f7f7';
        const shadowWidth = 7;

        return LineLayers.lineWithShadow(
            id,
            lineColor,
            lineWidth,
            shadowColor,
            shadowWidth
        );
    };

    static traccarTrackerPositions = () => {
        const id = 'traccar-tracker-positions';
        const circleRadius = 9;
        const color = [
            'match',
            ['get', 'teamStatus'],
            1,
            '#add8e6',
            2,
            '#f08080',
            3,
            '#ff4040',
            4,
            '#1e90ff',
            5,
            '#7cfc00',
            6,
            '#ffff00',
            '#2f373b', // default color
        ];
        const circleBorder = 6;
        const borderColor = [
            'match',
            ['get', 'teamStatus'],
            1,
            '#000000',
            2,
            '#000000',
            3,
            '#000000',
            4,
            '#000000',
            5,
            '#000000',
            6,
            '#000000',
            '#e31837', // default color
        ];
        const shadowRadius = 18;
        const shadowColor = '#ffffff';
        const textSize = 14;
        const textColor = '#000000';
        const textShadowSize = 3;
        const textShadowColor = '#ffffff';

        return MarkerLayers.unitPosition(
            id,
            circleRadius,
            color,
            circleBorder,
            borderColor,
            shadowRadius,
            shadowColor,
            textSize,
            textColor,
            textShadowSize,
            textShadowColor
        );
    };

    static fzmTrackerPositions = () => {
        const id = 'fzm-tracker-positions';
        const circleRadius = 12;
        const color = [
            'match',
            ['get', 'teamStatus'],
            1,
            '#add8e6',
            2,
            '#f08080',
            3,
            '#ff4040',
            4,
            '#1e90ff',
            5,
            '#7cfc00',
            6,
            '#ffff00',
            '#cccccc', // default color
        ];
        const circleBorder = 3;
        const borderColor = '#000000';
        const shadowRadius = 17;
        const shadowColor = '#ffffff';
        const textSize = 14;
        const textColor = '#000000';
        const textShadowSize = 3;
        const textShadowColor = '#ffffff';

        return MarkerLayers.unitPosition(
            id,
            circleRadius,
            color,
            circleBorder,
            borderColor,
            shadowRadius,
            shadowColor,
            textSize,
            textColor,
            textShadowSize,
            textShadowColor
        );
    };
}
